/* Kaio-Dia - fiche produit.

   1. Reference et etat du stock en phase avec la variante choisie
      (en stock, rupture ou precommande).
   2. Fenetre du guide des tailles.
   3. Bloc d onglets : onglets sur grand ecran, accordeons sur mobile, avec
      un seul contenu dans la page.

   Pour savoir quelle variante est active, on lit d abord le parametre
   ?variant= de l URL, que FullStack met a jour a chaque changement. C est la
   source la plus fiable : la page contient plusieurs champs [name="id"]
   caches (formulaire principal, achat rapide, ventes croisees) et le premier
   trouve n est pas toujours celui du produit affiche.

   Fichier maison, jamais ecrase par une mise a jour de FullStack. */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 750px)';

  /* ---------- Reference et stock ---------- */

  function parse(meta) {
    var tag = meta.querySelector('[data-kd-variant-data]');
    if (!tag) return null;
    try {
      return JSON.parse(tag.textContent);
    } catch (e) {
      return null;
    }
  }

  function currentId(meta, list) {
    var known = {};
    for (var i = 0; i < list.length; i++) known[String(list[i].id)] = true;

    try {
      var fromUrl = new URL(window.location.href).searchParams.get('variant');
      if (fromUrl && known[String(fromUrl)]) return String(fromUrl);
    } catch (e) {}

    var scope = meta.closest('.shopify-section') || document;
    var inputs = scope.querySelectorAll('[name="id"]');
    for (var k = 0; k < inputs.length; k++) {
      var v = String(inputs[k].value || '');
      if (known[v]) return v;
    }
    return '';
  }

  function sync(meta) {
    var list = parse(meta);
    if (!list || !list.length) return;

    var id = currentId(meta, list);
    var variant = null;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === id) { variant = list[i]; break; }
    }
    if (!variant) variant = list[0];

    var stock = meta.querySelector('[data-kd-stock]');
    var stockText = meta.querySelector('[data-kd-stock-text]');
    if (stock && stockText) {
      var state = variant.available === true ? (variant.pre === true ? 'pre' : 'in') : 'out';
      stock.classList.toggle('kd-stock--in', state === 'in');
      stock.classList.toggle('kd-stock--pre', state === 'pre');
      stock.classList.toggle('kd-stock--out', state === 'out');
      var label = meta.getAttribute('data-kd-' + state);
      if (label) stockText.textContent = label;
    }

    var sku = meta.querySelector('[data-kd-sku]');
    var skuValue = meta.querySelector('[data-kd-sku-value]');
    if (sku && skuValue) {
      if (variant.sku) {
        skuValue.textContent = variant.sku;
        sku.removeAttribute('hidden');
      } else {
        skuValue.textContent = '';
        sku.setAttribute('hidden', '');
      }
    }

    /* Ligne "Expedie sous 24-48 h" (snippets/kd-reassure.liquid) : masquee
       quand la variante choisie est en precommande. Ajout du 12/10/2026. */
    var scope = meta.closest('.shopify-section') || document;
    var dispatch = scope.querySelectorAll('[data-kd-dispatch]');
    for (var d = 0; d < dispatch.length; d++) {
      if (variant.pre === true) dispatch[d].setAttribute('hidden', '');
      else dispatch[d].removeAttribute('hidden');
    }
  }

  function syncAll() {
    var metas = document.querySelectorAll('[data-kd-meta]');
    for (var i = 0; i < metas.length; i++) sync(metas[i]);
  }

  /* Le selecteur de variantes utilise des champs radio et des boutons, et il
     met l URL a jour juste apres le clic : on repasse a 80 puis 350 ms pour
     ne pas dependre de son calendrier exact. */
  function syncSoon() {
    setTimeout(syncAll, 80);
    setTimeout(syncAll, 350);
  }

  /* ---------- Onglets ---------- */

  function isDesktop() {
    return window.matchMedia && window.matchMedia(DESKTOP).matches;
  }

  function selectTab(root, name) {
    var tabs = root.querySelectorAll('[data-kd-tab]');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].setAttribute('aria-selected', tabs[i].getAttribute('data-kd-tab') === name ? 'true' : 'false');
    }
    var panels = root.querySelectorAll('[data-kd-panel]');
    for (var k = 0; k < panels.length; k++) {
      var on = panels[k].getAttribute('data-kd-panel') === name;
      panels[k].classList.toggle('is-active', on);
      /* En mode onglets un seul panneau est visible, et il doit etre ouvert
         pour que son contenu s affiche si on repasse en mode accordeon. */
      panels[k].classList.toggle('is-open', on);
      var head = panels[k].querySelector('[data-kd-panel-toggle]');
      if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
  }

  function togglePanel(panel) {
    var open = !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    var head = panel.querySelector('[data-kd-panel-toggle]');
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initTabs() {
    var roots = document.querySelectorAll('[data-kd-tabs]');
    for (var i = 0; i < roots.length; i++) {
      var first = roots[i].querySelector('[data-kd-panel]');
      if (first) selectTab(roots[i], first.getAttribute('data-kd-panel'));
    }
  }

  /* ---------- Clics ---------- */

  function onClick(event) {
    var t = event.target;
    if (!t || !t.closest) return;

    var tab = t.closest('[data-kd-tab]');
    if (tab) {
      event.preventDefault();
      selectTab(tab.closest('[data-kd-tabs]'), tab.getAttribute('data-kd-tab'));
      return;
    }

    var head = t.closest('[data-kd-panel-toggle]');
    if (head && !isDesktop()) {
      event.preventDefault();
      togglePanel(head.closest('[data-kd-panel]'));
      return;
    }

    var open = t.closest('[data-kd-sizeguide-open]');
    if (open) {
      var wrap = open.closest('.kd-sizeguide');
      var dialog = wrap && wrap.querySelector('[data-kd-sizeguide-dialog]');
      if (dialog) {
        event.preventDefault();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }
      return;
    }

    var close = t.closest('[data-kd-sizeguide-close]');
    if (close) {
      var d = close.closest('[data-kd-sizeguide-dialog]');
      if (d) {
        event.preventDefault();
        if (typeof d.close === 'function') d.close();
        else d.removeAttribute('open');
      }
      return;
    }

    /* Clic sur le fond sombre : la cible est alors la fenetre elle-meme. */
    if (t.matches && t.matches('[data-kd-sizeguide-dialog]')) {
      var rect = t.getBoundingClientRect();
      var inside =
        event.clientX >= rect.left && event.clientX <= rect.right &&
        event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside && typeof t.close === 'function') t.close();
    }
  }

  document.addEventListener('click', onClick);
  document.addEventListener('change', syncSoon, true);
  document.addEventListener('click', syncSoon, true);
  window.addEventListener('popstate', syncSoon);

  function boot() {
    syncAll();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
